module.exports = __webpack_public_path__ + "static/media/UCA-Rhombus-Blue.04572504.svg";